import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IconName } from '../../icons';
import { ActionFilter } from '../../loading';

@Component({
  selector: 'yat-buttons',
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.scss']
})
export class ButtonsComponent {
  @Input()
  primaryButtonName: string;

  @Input()
  primaryButtonId: string;

  @Input()
  primaryButtonSuffixIcon: IconName;

  @Input()
  secondaryButtonName: string;

  @Input()
  className: string = '';

  @Input()
  secondaryButtonId: string;

  @Input()
  useYatAutoSpinner: ActionFilter | boolean = true;

  @Input()
  asyncForm: FormGroup;

  @Input()
  negativePrimaryButton: boolean = false;

  @Input()
  verticalAlignment: boolean = false;

  @Input()
  disablePrimaryButton: boolean = false;

  @Input()
  matomoEventCategory: string | undefined;

  @Input()
  matomoEventClickPrimaryButtonAction: string | undefined;

  @Input()
  matomoEventClickSecondaryButtonAction: string | undefined;

  @Input()
  matomoEventName: string | undefined;

  @Output()
  primaryButtonClickMethod: EventEmitter<void> = new EventEmitter();

  @Output()
  secondaryButtonClickMethod: EventEmitter<void> = new EventEmitter();

  secondaryButtonClick(): void {
    this.secondaryButtonClickMethod.emit();
  }

  primaryButtonClick(): void {
    this.primaryButtonClickMethod.emit();
  }
}
